import { __awaiter, __generator, __read } from "tslib";
export function getTokenProviders(officeContextPromise, userEntitlementsPromise) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, officeContext, userEntitlements, getAccessToken, sharePointResourceId, bingTokenProvider, graphTokenProvider, lokiTokenProvider, odsTokenProvider, sharePointTokenProvider, substrateTokenProvider, tenantFeedbackTokenProvider, thorTokenProvider;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, Promise.all([
                        officeContextPromise,
                        userEntitlementsPromise,
                    ])];
                case 1:
                    _a = __read.apply(void 0, [_b.sent(), 2]), officeContext = _a[0], userEntitlements = _a[1];
                    getAccessToken = officeContext.getAccessToken;
                    sharePointResourceId = userEntitlements.SharePointResourceId;
                    bingTokenProvider = function (_) {
                        return getAccessToken('BingAnswers').then(function (response) { return response.token; });
                    };
                    graphTokenProvider = function (_) {
                        return getAccessToken('Graph').then(function (response) { return response.token; });
                    };
                    lokiTokenProvider = function (_) {
                        return getAccessToken('Loki').then(function (response) { return response.token; });
                    };
                    odsTokenProvider = function (_) {
                        return getAccessToken('Ods').then(function (response) { return response.token; });
                    };
                    sharePointTokenProvider = function (_a) {
                        var url = _a.url, attempt = _a.attempt;
                        var isRetry = attempt === 1;
                        var resource = url !== null && url !== void 0 ? url : sharePointResourceId;
                        return getAccessToken('SharePoint', isRetry, resource).then(function (response) { return response.token; });
                    };
                    substrateTokenProvider = function (_) {
                        return getAccessToken('QueryFormulation').then(function (response) { return response.token; });
                    };
                    tenantFeedbackTokenProvider = function (_) {
                        return getAccessToken('TenantFeedback').then(function (response) { return response.token; });
                    };
                    thorTokenProvider = function (_) {
                        return getAccessToken('Thor').then(function (response) { return response.token; });
                    };
                    return [2 /*return*/, {
                            bingTokenProvider: bingTokenProvider,
                            graphTokenProvider: graphTokenProvider,
                            lokiTokenProvider: lokiTokenProvider,
                            odsTokenProvider: odsTokenProvider,
                            sharePointTokenProvider: sharePointTokenProvider,
                            substrateTokenProvider: substrateTokenProvider,
                            tenantFeedbackTokenProvider: tenantFeedbackTokenProvider,
                            thorTokenProvider: thorTokenProvider,
                        }];
            }
        });
    });
}
//# sourceMappingURL=getTokenProviders.js.map